import React from "react";
import { createUseStyles } from "react-jss";
var useStyles = createUseStyles({
    root: {
        display: "flex",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#FFF",
        borderRadius: "50%",
        width: 32,
        height: 32,
    },
});
var ActionIcon = function () {
    var classes = useStyles();
    return (React.createElement("div", { className: classes.root },
        React.createElement("svg", { width: "10", height: "19", viewBox: "0 0 10 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M1 1L9 9.5L1 18", stroke: "black" }))));
};
export default ActionIcon;
